export default {
  hexCode: {
    id: 'SIMPLE_COLOR_PICKER_HEX_CODE',
    defaultMessage: 'Hex Code',
    description: 'Message for the hex code label in the simple color picker',
  },
};
